(function () {
  //initialize DAC object
  window.DAC = window.DAC || {};

  // Check if already initialized - exit early if so
  if (window.DAC.megaMenuInitialized) return;
  window.DAC.megaMenuInitialized = true;

  let productForms = document.querySelectorAll("[data-form-type='drawer_cart']");
  if (!productForms) return;

  productForms.forEach((productForm) => {
    let formSelect = productForm.querySelector('.megamenu_product_form_options');

    //if form does not exist continue to next iteration
    if (!formSelect) return;

    let currentId = null;
    let currentImage = null;
    formSelect.addEventListener('change', () => {
      Array.from(formSelect.children).forEach((option) => {
        if (option.value == formSelect.value) {
          currentId = option.value;
          currentImage = option.dataset.image;
        }
      });
      productForm.action = `/cart/add/${currentId}`;
      productForm.querySelector("input[name='id']").value = currentId;
      productForm.querySelector("button[type='submit']").value = currentId;
      productForm.querySelector('.megamenu_product_image').src = currentImage;
    });
  });
})();
